import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'el',
    fullName: 'Greek',
    nativeName: 'Ελληνικά',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "Κάτι Καταπληκτικό Έρχεται",
    landing_subtitle: "Το ArgVoid είναι ένα στούντιο ανάπτυξης εφαρμογών και παιχνιδιών. Μείνετε συντονισμένοι, νέα πράγματα έρχονται σύντομα!",
    select_language: "Επιλέξτε Γλώσσα",
    search_placeholder: "Αναζήτηση γλωσσών...",
    terms_title: "Όροι Παροχής Υπηρεσιών",
    policy_title: "Πολιτική Απορρήτου",
    cookies_title: "Πολιτική cookie",
    terms_content: `
        Χ0Χ1. Αποδοχή των ΌρωνΧ1ΧΧ2Χ
        Με την πρόσβαση στο ArgVoid, αυτοί οι Όροι Παροχής Υπηρεσιών γίνονται αποδεκτοί. Εάν αυτοί οι όροι δεν συμφωνηθούν, η υπηρεσία δεν θα πρέπει να χρησιμοποιηθεί.<br><br>

        Χ5Χ2. Χρήση πλατφόρμας</strong><br>
        Το ArgVoid και οι εφαρμογές του παρέχονται "ως έχουν" για ενημερωτικούς και δημιουργικούς σκοπούς. Η υπηρεσία πρέπει να χρησιμοποιείται μόνο για νόμιμους σκοπούς.<br><br>

        Χ10Χ3. Απαγορευμένη Συμπεριφορά</strong><br>
        Απαγορεύεται αυστηρά η εκμετάλλευση τρωτών σημείων του ιστότοπου, η αποστολή ανεπιθύμητης αλληλογραφίας ή η προσπάθεια μη εξουσιοδοτημένης πρόσβασης στην υποδομή.<br><br>

        Χ15Χ4. Αποποίηση ευθυνών</strong><br>
        Η πλατφόρμα και οι υπηρεσίες μπορούν να τροποποιηθούν ανά πάσα στιγμή χωρίς προειδοποίηση. Δεν παρέχεται καμία εγγύηση σχετικά με το χρόνο λειτουργίας ή τη διαθεσιμότητα της υπηρεσίας.
    `,
    policy_content: `
        Χ0Χ1. Συλλογή ΠληροφοριώνΧ1ΧΧ2Χ
        Η πλατφόρμα δεν απαιτεί έλεγχο ταυτότητας χρήστη ή δημιουργία λογαριασμού αυτήν τη στιγμή. Δεν συλλέγονται ενεργά προσωπικά στοιχεία ταυτοποίησης (όπως ονόματα ή διευθύνσεις ηλεκτρονικού ταχυδρομείου) από επισκέπτες.<br><br>

        Χ5Χ2. Χρήση Data</strong><br>
        Μπορούν να συλλεχθούν βασικά, ανώνυμα αναλυτικά στοιχεία για την κατανόηση της επισκεψιμότητας του ιστότοπου και τη βελτίωση των εφαρμογών. Αυτά τα δεδομένα δεν συνδέονται με μεμονωμένες ταυτότητες χρηστών.<br><br>

        Χ10Χ3. Υπηρεσίες τρίτων </strong><br>
        Τρίτοι πάροχοι μπορούν να χρησιμοποιηθούν για υπηρεσίες φιλοξενίας και ανάλυσης. Οι πρακτικές απορρήτου αυτών των αντίστοιχων παρόχων διέπουν τα ανώνυμα δεδομένα που υποβάλλονται σε επεξεργασία στην υποδομή τους.<br><br>

        Χ15Χ4. Ασφάλεια δεδομένων</strong><br>
        Εφαρμόζονται εύλογα μέτρα ασφαλείας για την προστασία της πλατφόρμας. Ωστόσο, καμία μέθοδος μετάδοσης μέσω Διαδικτύου δεν είναι απολύτως ασφαλής.<br><br>
    `,
    cookies_content: `
        Χ0Χ1. Τι είναι τα cookie και ο τοπικός χώρος αποθήκευσης; </strong><br>
        Τα cookie και ο τοπικός χώρος αποθήκευσης του προγράμματος περιήγησης είναι μικρά αρχεία δεδομένων που αποθηκεύονται στη συσκευή για να θυμούνται τις προτιμήσεις διαμόρφωσης στις επισκέψεις.<br><br>

        Χ5Χ2. Σκοπός χρήσης</strong><br>
        Το πρόγραμμα περιήγησης LocalStorage χρησιμοποιείται αυστηρά για την αποθήκευση ρυθμίσεων διαμόρφωσης, όπως:<br>
        - Προτιμήσεις γλώσσας<br>
        - Διαμόρφωση διεπαφής χρήστη (π.χ. ρυθμίσεις διάταξης ή θέματος) <br>
        - Προσωρινή προσωρινή μνήμη εφαρμογής<br><br>

        Χ13Χ3. Χωρίς παρακολούθηση</strong><br>
        Τα cookies και η τοπική αποθήκευση δεν χρησιμοποιούνται για σκοπούς διαφήμισης ή παρακολούθησης τρίτων. Όλα τα αποθηκευμένα δεδομένα προορίζονται αυστηρά για τη βασική λειτουργικότητα της πλατφόρμας.<br><br>

        Χ18Χ4. Control</strong><br>
        Τα δεδομένα του προγράμματος περιήγησης μπορούν να διαγραφούν ανά πάσα στιγμή μέσω των ρυθμίσεων του προγράμματος περιήγησης, οι οποίες θα επαναφέρουν τυχόν τοπικές διαμορφώσεις.
    `,
    cookie_consent_text: "Χρησιμοποιούμε βασικά cookies για να διασφαλίσουμε ότι ο ιστότοπος λειτουργεί σωστά, όπως η διατήρηση της συνεδρίας ενεργής, η αποθήκευση της προτίμησης γλώσσας και άλλες προσαρμοσμένες διαμορφώσεις.",
    read_policy: "Διαβάστε την Πολιτική cookie",
    support_title: "Επικοινωνήστε με την Υποστήριξη",
    support_subject_label: "Θέμα",
    support_message_label: "Μήνυμα",
    support_submit_button: "Αποστολή μηνύματος",
    support_hint: "Σημείωση: Αυτό θα ανοίξει την προεπιλεγμένη εφαρμογή email για να στείλετε το μήνυμα.",
    support_success_msg: "Άνοιγμα της εφαρμογής email σας...",
    support_error_msg: "Αποτυχία αποστολής μηνύματος. Δοκιμάστε ξανά αργότερα.",
    explorer_title: "Εξερευνητής",
    history_title: "Ιστορία",
    animation_title: "Εμψύχωση",
    config_title: "Διαμόρφωση",
    tool_mouse: "Επιλογή (Ctrl+M)",
    tool_brush: "Βούρτσα (Ctrl+B)",
    tool_brush_mode: "Λειτουργία εναλλαγής (Στερεά/Διαγραφή)",
    tool_eraser: "Γόμα (Ctrl+E)",
    tool_brush_size: "Προσαρμόστε το μέγεθος της βούρτσας",
    tool_bucket: "Γέμισμα (Ctrl+F)",
    tool_eyedropper: "Σταγονόμετρο",
    tool_grid: "Πλέγμα (Ctrl+Shift+B)",
    tool_rotate: "Περιστροφή (Ctrl+Shift+R)",
    tool_flip_h: "Αναστροφή H (Ctrl+Shift+H)",
    tool_flip_v: "Αναστροφή V (Ctrl+Shift+V)",
    tool_transpose: "Μεταφορά (Ctrl+Shift+T)",
    label_width: "Πλάτος",
    label_height: "Υψος",
    label_frames: "Αριθμός πλαισίων",
    label_animation: "Στυλ κινουμένων σχεδίων",
    label_background_color: "Χρώμα φόντου",
    label_interval: "Διάστημα",
    tool_anim_config: "Διαμόρφωση κινούμενων εικόνων",
    label_new_width: "Νέο Πλάτος",
    label_new_height: "Νέο Ύψος",
    label_apply: "Εφαρμόζω",
    label_colors: "Χρωματιστά",
    label_size: "Μέγεθος",
    label_tolerance: "Ανοχή",
    val_horizontal: "Οριζόντιος",
    val_vertical: "Κατακόρυφος",
    val_sequence: "Αλληλουχία",
    val_bounce: "Πήδημα",
    val_random: "Τυχαίος",
    val_solid: "Στερεός",
    val_clear: "Σαφής",
    action_add_sheet: "Νέο Φύλλο",
    action_import: "Εισαγωγή",
    action_export: "Εξαγωγή",
    action_sort_projects: "Είδος",
    sort_date_old: "Πρώτος παλαιότερος",
    sort_date_new: "Πρώτα τα νεότερα",
    sort_name_az: "Όνομα (A-Z)",
    sort_name_za: "Όνομα (Z-A)",
    action_new_sprite: "New Sprite",
    action_new_project: "Νέο Έργο",
    modal_save_all_title: "Αποθήκευση όλων των αλλαγών",
    modal_save_all_desc: "Επιλέξτε τα στοιχεία προς αποθήκευση:",
    modal_save_selected: "Αποθήκευση επιλεγμένων",
    action_saved: "Αποθηκεύτηκε",
    modal_create_sprite_title: "Δημιουργία New Sprite",
    modal_create_project_title: "Δημιουργία νέου έργου",
    modal_add_sheet_title: "Προσθήκη νέου φύλλου",
    modal_rename_sheet_title: "Μετονομασία φύλλου",
    modal_rename_sprite_title: "Μετονομασία Sprite",
    modal_delete_sprite_title: "Διαγραφή Sprite",
    modal_delete_project_title: "Διαγραφή έργου",
    modal_delete_sheet_title: "Διαγραφή φύλλου",
    placeholder_sprite_name: "Ονομα",
    placeholder_project_name: "Ονομα",
    placeholder_sheet_name: "Ονομα",
    placeholder_new_name: "Νέο Όνομα",
    action_create: "Δημιουργώ",
    action_add: "Προσθέτω",
    action_rename: "Μετονομάζω",
    action_duplicate: "Αντίγραφο",
    action_delete: "Διαγράφω",
    action_cancel: "Ματαίωση",
    confirm_delete_sprite: "Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτό το ξωτικό;",
    confirm_delete_project: "Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτό το έργο; Όλα τα sprites θα αφαιρεθούν.",
    confirm_delete_sheet: "Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτό το φύλλο;",
    err_select_sprite: "Επιλέξτε πρώτα ένα sprite.",
    err_select_project: "Επιλέξτε πρώτα ένα έργο.",
    err_name_empty: "Το όνομα δεν μπορεί να είναι κενό.",
    err_sprite_exists: "Ένα ξωτικό με αυτό το όνομα υπάρχει ήδη.",
    err_project_exists: "Υπάρχει ήδη ένα έργο με αυτό το όνομα.",
    err_no_content: "Δεν υπάρχει περιεχόμενο για αποθήκευση.",
    err_no_changes: "Δεν υπάρχουν αλλαγές για αποθήκευση.",
    err_delete_last_sheet: "Δεν είναι δυνατή η διαγραφή του τελευταίου φύλλου.",
    err_extract_frames: "Δεν ήταν δυνατή η εξαγωγή πλαισίων.",
    err_indexeddb: "Αποτυχία αποθήκευσης τοπικά. Το πρόγραμμα περιήγησής σας ενδέχεται να μην υποστηρίζει το IndexedDB.",
    msg_upload_success: "Η μεταφόρτωση ολοκληρώθηκε με επιτυχία: {0}",
    msg_upload_failed: "Η μεταφόρτωση απέτυχε: {0}",
    msg_save_success: "Η αποθήκευση είναι επιτυχής.",
    msg_saving: "Οικονομία...",
    msg_multi_save_result: "Αποθηκεύτηκαν {0} στοιχεία. {1} αποτυχίες.",
    menu_title: "Μενού",
    menu_save: "Εκτός",
    menu_save_all: "Αποθήκευση όλων",
    menu_support: "Επικοινωνήστε με την Υποστήριξη",
    label_local_storage: "Τοπική αποθήκευση",
    label_sign_in: "Είσοδος",
    modal_export_title: "Εξαγωγή Sprite",
    label_filename: "Όνομα αρχείου",
    label_format: "Σχήμα και διάταξις βιβλίου",
    action_export_confirm: "Εξαγωγή",
};

export default translations;
